/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { useRef, useEffect, Fragment } from "react"
import { Flex, SectionGrid } from "frontend/src/components/Layout"
import { BlockText } from "../../components/BlockText"
import { Touchable } from "../../components/Touchable"
import { useDebugState } from "use-named-state"
/* eslint-disable react-hooks/exhaustive-deps */

const partition = (array, func) => {
  return array.reduce(
    (acc, val, i, array) => {
      acc[func(val, i, array) ? 0 : 1].push(val)
      return acc
    },
    [[], []]
  )
}

const getPaymentMethod = value => {
  switch (value) {
    case "1":
      return "Banküberweisung"
    case "3":
      return "PayPal"
    case "6":
      return "Gutschein"
    case "22":
      return "Andere"
    case "25":
      return "Klarna (Rechnung)"
    case "26":
      return "Rechnung"
    case "31":
      return "Kreditkarte"
    case "39":
      return "Klarna (Ratenzahlung)"
    case "59":
      return "Vorkasse"
    case "61":
      return "Amazon Marketplace"
    case "79":
      return "PayPal Express"
    case "98":
      return "Klarna"
    case "104":
      return "eBay"
    default:
      return "unbekannt"
  }
}

const translateState = status => {
  switch (status) {
    case "delivered":
      return "an Empfänger*in zugestellt"
    case "packstation":
      return "an Packstation zugestellt"
    case "paketshop":
      return "an Paketshop/Postfiliale zugestellt"
    case "transit":
      return "Zustellung läuft"
    case "pre-transit":
      return "Paketdaten an DHL übermittelt"
    case "pending":
      return "Auftrag wird von sleep.ink bearbeitet"
    case "return":
      return "zurückgesendet an sleep.ink"
    case "failure":
      return "Fehler bei der Zustellung"
    case "unknown":
      return "unbekannter Status"
    default:
      return "unbekannter Status"
  }
}

const translateDhl = message => {
  switch (message) {
    case "The instruction data for this shipment have been provided by the sender to DHL electronically":
      return "Die Sendung wurde elektronisch angekündigt."
    case "The shipment has been processed in the parcel center of origin":
      return "Die Sendung wurde von DHL bearbeitet und wird für den Weitertransport in die Region des Empfängers vorbereitet."
    case "The shipment arrived in the region of recipient and will be transported to the delivery base in the next step.":
      return "Die Sendung ist in der Region des Empfängers angekommen und wird im nächsten Schritt zur Zustellbasis transportiert."
    case "The shipment has been loaded onto the delivery vehicle":
      return "Die Sendung wurde in das Zustellfahrzeug geladen. Die Zustellung erfolgt voraussichtlich heute."
    case "The shipment could not be delivered today.":
      return "Leider war eine Zustellung der Sendung heute nicht möglich. Mögliche Gründe: Abbruch der Zustelltour aufgrund von Krankheit, Unfall, Überschreitung der Arbeitszeit. Wir versuchen es am nächsten Werktag."
    case "The shipment has been successfully delivered":
      return "Die Sendung wurde erfolgreich zugestellt."
    case "The shipment has been processed in the delivery base.":
      return "Die Sendung wird für die Verladung ins Zustellfahrzeug vorbereitet."
    case "The shipment is on its way to the PACKSTATION":
      return "Die Sendung befindet sich auf dem Weg zur Packstation."
    case "The shipment has been processed in the parcel center":
      return "Die Sendung wird zum Weitertransport vorbereitet."
    case "The shipment could not be delivered to the PACKSTATION and has been forwarded to a retail outlet. The recipient has been notified.":
      return "Die Sendung konnte leider nicht in die gewünschte Packstation eingestellt werden und wird zur Abholung in eine Filiale gebracht."
    case "The shipment could not be delivered and is being forwarded to a PACKSTATION. The recipient has been notified.":
      return "Die Sendung konnte nicht zugestellt werden und wird in eine Packstation gebracht."
    case "The shipment could not be delivered, and the recipient has been notified.":
      return "Die Sendung konnte nicht zugestellt werden und wird in die Filiale gebracht. Für die Abholung ist neben der Benachrichtigung die Vorlage ihres Ausweises sowie ggf. eine Vollmacht erforderlich."
    case "The recipient has not picked up the shipment from the retail outlet within the seven-day storage period":
      return "Der Empfänger hat die Sendung innerhalb der siebentägigen Lagerfrist nicht in der Filiale abgeholt."
    case "The shipment was prepared for onward transport.":
      return "Die Sendung wurde für den Weitertransport vorbereitet."
    case "The shipment has been postponed and will probably be delivered on the next working day":
      return "Die Sendung wurde zurückgestellt. Die Zustellung erfolgt vrs. am nächsten Werktag."
    case "The international shipment has been processed in the parcel center of origin":
      return "Die Auslandssendung wurde an DHL übergeben und wird für den Weitertransport in das Zielland/Zielgebiet vorbereitet."
    case "The international shipment has been processed in the export parcel center":
      return "Die Auslandssendung wurde im Export-Paketzentrum bearbeitet und ist auf dem Weg in die Region des Empfängers."
    case "A 2nd attempt at delivery is being made":
      return "Leider war eine Zustellung ihrer Sendung heute nicht möglich. Wir versuchen es am nächsten Werktag."
    case "The shipment has arrived at the parcel center":
      return "Die Sendung ist im Paketzentrum eingetroffen."
    case "The shipment has arrived in the destination country/destination area":
      return "Die Sendung ist im Zielland/Zielgebiet eingetroffen."
    case "The shipment could not be delivered":
      return "Die Sendung konte nicht zugestellt werden."
    case "The shipment is ready for pick-up by the recipient.":
      return "Die Sendung liegt für den Empfänger zur Abholung bereit."
    case "The slightly damaged shipment is being repackaged":
      return "Die geringfügig beschädigte Sendung wurde nachverpackt und wird jetzt zum Empfänger transportiert."
    case "Shipment is prepared for customs clearance in the destination country/destination area":
      return "Die Sendung wird zur Verzollung im Zielland/Zielgebiet vorbereitet."
    case "The shipment is being prepared for delivery in the delivery depot":
      return "Die Sendung wird im Zustell-Depot für die Zustellung vorbereitet."
    case "The shipment is being stored at the delivery depot because a specific delivery day has been requested (order by the recipient).":
      return "Ihr Paket wird bei uns gelagert und am gewünschten Liefertag zugestellt."
    case "The recipient has picked up the shipment from the retail outlet":
      return "Der Empfänger hat die Sendung in der Filiale abgeholt."
    case "Unfortunately, the delivery of the shipment was not possible. Reasons for this could be: No access to the building, no sign on the bell, receiver moved.":
      return "Leider war eine Zustellung der Sendung nicht möglich. Gründe hierfür können sein: Kein Zugang zum Gebäude, kein Schild an der Klingel, Empfänger verzogen."
    default:
      if (/^The shipment is being brought to/.test(message)) {
        const paketshopArray = message.match(/to (.*) for pick-up/)
        const paketshopLink = paketshopArray[1].replace("retail outlet", "Filiale")
        return `Die Sendung wurde zur Abholung in die ${paketshopLink} gebracht. Die frühestmögliche Uhrzeit der Abholung kann der Benachrichtigung entnommen werden.`
      }
      if (/^The shipment is available for pick-up from the retail outlet/.test(message)) {
        const paketshopArray = message.match(/from the retail outlet (.*) as/)
        const paketshopLink = paketshopArray[1].replace("retail outlet", "Filiale")
        return `Die Sendung liegt ab sofort in der ${paketshopLink} zur Abholung bereit.`
      }
      if (/^The shipment is ready for pick-up at the/.test(message)) {
        const packstationArray = message.match(/at the (.*)\.$/)
        const packstationLink = packstationArray[1]
        return `Die Sendung liegt in der ${packstationLink} zur Abholung bereit.`
      }
      if (
        /^The shipment will be transported to the destination country\/destination area and, from there, handed over/.test(
          message
        )
      ) {
        const deliveryOrgArray = message.match(/tracking: (.*)/) || []
        const deliveryOrgLink = deliveryOrgArray.length >= 2 ? deliveryOrgArray[1].slice(0, -1) : ""
        return deliveryOrgLink.length > 0
          ? `Die Sendung wird ins Zielland/Zielgebiet transportiert und dort an die Zustellorganisation übergeben (Sendungsverfolgung im Ausland: ${deliveryOrgLink})`
          : ""
      }
      return message
  }
}

const styles = {
  box: {
    borderColor: "rgba(47,78,37,0.15)",
    borderStyle: "solid",
    borderWidth: "1px",
    py: 4,
    my: 3,
  },
}

function getFinalState(array, finalState) {
  if (finalState === "return") {
    return "return"
  } else if (array.includes("delivered")) {
    return "delivered"
  } else if (array.includes("packstation")) {
    return "packstation"
  } else if (array.includes("paketshop")) {
    return "paketshop"
  } else if (array[0] === "transit") {
    return "transit"
  } else if (array[0] === "pre-transit") {
    return "pre-transit"
  } else if (finalState === "pending") {
    return "pending"
  } else if (array.includes("failure")) {
    return "failure"
  } else {
    return "unknown"
  }
}

function ErrorWindow({ error }) {
  const { orderNo, zip, extra } = error
  const message = [orderNo, zip, extra].join(" ").trim()
  return (
    <div
      sx={{
        width: "100%",
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: "accent",
        color: "accent",
        padding: 4,
      }}
    >
      {message}
    </div>
  )
}

function OrderRequest({ title, text }) {
  const [height, setHeight] = useDebugState("height", 0)
  const [orderNumber, setOrderNumber] = useDebugState("orderNumber", "")
  const [zipCode, setZipCode] = useDebugState("zipCode", "")
  const [shipmentData, setShipmentData] = useDebugState("shipmentData", {})
  const [error, setError] = useDebugState("error", {
    orderNo: null,
    zip: null,
    extra: null,
  })
  const WrapperRef = useRef(null)
  try {
    useEffect(() => {
      const postDimensions = () => {
        if (
          window &&
          WrapperRef.hasOwnProperty("current") &&
          height !== WrapperRef.current.offsetHeight
        ) {
          const myHeight = Math.max(
            height,
            WrapperRef.current.offsetHeight,
            WrapperRef.current.scrollHeight
          )
          setHeight(myHeight)
          window.parent.postMessage({ frameHeight: myHeight }, "*")
          /*console.log(myHeight);*/
        }
      }
      postDimensions()
      if (window) {
        window.onload = () => postDimensions()
        window.onresize = () => postDimensions()
      }
    }, [])
  } catch (error) {
    console.dir(error)
  }
  const handleOrdnerNoChange = async (event, modus) => {
    event.preventDefault()
    if (modus !== "change" && modus !== "paste") return null
    let ono
    if (modus === "change") {
      ono = event.target.value
    } else {
      ono = event.clipboardData.getData("text")
    }
    if (ono === "") {
      setOrderNumber(ono)
      setError({ ...error, orderNo: "Sie müssen eine Bestellnummer eingeben.", extra: null })
    } else {
      setError({ ...error, orderNo: null, extra: null })
      setOrderNumber(ono)
    }
  }
  const handleZipCodeChange = (event, modus) => {
    event.preventDefault()
    if (modus !== "paste" && modus !== "change") return null
    let plz
    if (modus === "change") {
      plz = event.target.value
    } else {
      plz = event.clipboardData.getData("text")
    }
    if (plz === "") {
      setZipCode(plz)
      setError({ ...error, zip: "Sie müssen eine Postleitzahl eingeben.", extra: null })
    } else {
      setZipCode(plz)
      setError({ ...error, zip: null, extra: null })
    }
  }
  const getShipmentData = async e => {
    e.preventDefault()
    if (error.orderNo == null && error.zip == null) {
      const response = await fetch(
        `/.netlify/functions/shipmentData?name=${orderNumber}&zip=${zipCode}`
      )
      if (response.status === 500) {
        setError({
          ...error,
          extra:
            "Die Bestellung wurde nicht gefunden. Bitte überprüfen Sie Ihre Eingabe. Sollten Sie weiterhin Probleme in der Abfrage Ihrer Bestellung haben, kontaktieren Sie uns gerne direkt.",
        })
      } else {
        try {
          const data = await response.json()
          if (data.length === 0) {
            throw new Error(
              "Die Bestellung wurde nicht gefunden. Das kann mehrere Gründe haben: Möglicherweise ist sie bereits mehr als zwei Monate alt, möglicherweise ist sie noch nicht als bezahlt vermerkt, vielleicht ist sie zurückerstattet worden. Sollten Sie dennoch Fragen zu Ihrer Bestellung haben, dann kontaktieren Sie uns über den Support."
            )
          }
          const [dataset] = await data
          const {
            _createdAt: createdAt,
            _updatedAt: updatedAt,
            billbeeId,
            email,
            finalState,
            orderNumber,
            payedAt,
            paymentMethod,
            products = [],
            shippingNumbers = [],
            status,
            targetWeightKg,
            zipCode,
            name,
            dhlEvents = [],
          } = await dataset
          const [discounts, realProducts] = await partition(await products, o =>
            o.title.includes("Rabatt")
          )
          const isOnlySchlafduoProbe =
            (await realProducts.length) === 1 &&
            (await realProducts[0].title) === "10 Nächte Probieraktion Schlafduo"
          const trackingNumbers = (await isOnlySchlafduoProbe) ? [] : await shippingNumbers
          const trackingUrls = (await isOnlySchlafduoProbe)
            ? []
            : await shippingNumbers.map(
                number =>
                  `https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?idc=${number}`
              )
          const newDhlEvents = await dhlEvents.filter(item => item.hasOwnProperty("status"))
          const statusCodes = await newDhlEvents.map(item => item.statusCode)
          const newFinalState = await getFinalState(await statusCodes, await finalState)
          setError({ orderNo: null, zip: null, extra: null })
          setShipmentData({
            createdAt,
            updatedAt,
            billbeeId,
            discounts,
            email,
            finalState: newFinalState,
            orderNumber,
            payedAt,
            paymentMethod,
            products: realProducts,
            isOnlySchlafduoProbe,
            status,
            targetWeightKg,
            zipCode,
            name,
            shippingNumbers,
            trackingNumbers,
            trackingUrls,
            dhlEvents: newDhlEvents,
          })
        } catch (error) {
          setShipmentData({})
          setError({ orderNo: null, zip: null, extra: error.message })
        }
      }
    }
  }
  return (
    <SectionGrid sx={{ py: [8, 8, 11] }} Ref={WrapperRef}>
      <SectionGrid.narrow sx={{ px: [4, 6, 0] }}>
        <h2 sx={{ variant: "text.h2", mb: 7 }}>{title}</h2>
        {text && <BlockText blocks={text} />}
        <div
          sx={{
            mt: 7,
            mb: 5,
            display: "flex",
            flexDirection: ["column", "column", "row"],
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <input
            type="text"
            placeholder="Bestellnummer"
            // @ts-ignore
            value={orderNumber}
            onChange={e => handleOrdnerNoChange(e, "change")}
            onPaste={e => handleOrdnerNoChange(e, "paste")}
            sx={{
              padding: 4,
              fontSize: 1,
              color: "almostBlack",
              borderColor: "rgba(47,78,37,0,15)",
              borderStyle: "solid",
              borderWidth: "1px",
              fontWeight: "light",
              mr: [0, 0, 8],
              mb: [3, 3, 0],
            }}
          />
          <input
            type="text"
            placeholder="Postleitzahl"
            value={zipCode}
            onChange={e => handleZipCodeChange(e, "change")}
            onPaste={e => handleZipCodeChange(e, "paste")}
            // @ts-ignore
            sx={{
              padding: 4,
              fontSize: 1,
              color: "almostBlack",
              borderColor: "rgba(47,78,37,0,15)",
              borderStyle: "solid",
              borderWidth: "1px",
              fontWeight: "light",
              mr: [0, 0, 8],
              mb: [3, 3, 0],
            }}
            /* if enter is pressed, get order data */
            onKeyPress={e => {
              e.key === "Enter" && getShipmentData(e)
            }}
          />
          <Touchable
            sx={{
              px: 5,
              py: 4,
              backgroundColor: "almostBlack",
              color: "background",
              textTransform: "uppercase",
              fontWeight: "light",
              cursor: error.orderNo == null && error.zip == null ? "pointer" : "not-allowed",
            }}
            onClick={getShipmentData}
            disabled={
              error.orderNo == null && error.zip == null
                ? orderNumber.length === 0 || zipCode.length === 0
                  ? true
                  : false
                : true
            }
          >
            Lieferdaten anzeigen
          </Touchable>
        </div>
        {(error.orderNo != null || error.zip != null || error.extra != null) && (
          <ErrorWindow error={error} />
        )}
        {Object.keys(shipmentData).length > 0 && (
          <div sx={{ width: "100%" }}>
            <Flex.row justify="space-between" align="center" sx={{ width: "100%", mb: 4 }}>
              <span>Bestellnummer:</span>
              <span>{shipmentData.orderNumber}</span>
            </Flex.row>
            <Flex.row justify="space-between" align="center" sx={{ width: "100%", mb: 4 }}>
              <span>Postleitzahl:</span>
              <span>{shipmentData.zipCode}</span>
            </Flex.row>
            <Flex.row justify="space-between" align="center" sx={{ width: "100%", mb: 4 }}>
              <div sx={{ flexBasis: "180px", flexGrow: 0, flexShrink: 0 }}>
                Datum der Bestellung:
              </div>
              <span>
                {new Date(shipmentData.createdAt).toLocaleString("de-DE", {
                  timeZone: "Europe/Berlin",
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </Flex.row>
            <Flex.row justify="space-between" align="center" sx={{ width: "100%", mb: 4 }}>
              <div sx={{ flexBasis: "180px", flexGrow: 0, flexShrink: 0 }}>
                Status der Bezahlung:
              </div>
              <span>{shipmentData.payedAt ? "bezahlt" : "nicht bezahlt"}</span>
            </Flex.row>
            <Flex.row justify="space-between" align="center" sx={{ width: "100%", mb: 4 }}>
              <span>Art der Bezahlung:</span>
              <span>{getPaymentMethod(shipmentData.paymentMethod)}</span>
            </Flex.row>
            <Flex.row justify="space-between" align="center" sx={{ width: "100%", mb: 4 }}>
              <span sx={{ lineHeight: 1.18 }}>Status der Lieferung:</span>
              <div sx={{ textAlign: "right", lineHeight: 1.18 }}>
                {shipmentData.isOnlySchlafduoProbe
                  ? "Briefsendung"
                  : translateState(shipmentData.finalState)}
              </div>
            </Flex.row>
            <Flex.row justify="space-between" align="center" sx={{ width: "100%" }}>
              <span sx={{ fontWeight: "bold", fontFamily: "heading" }}>Produkte:</span>
              <span>{}</span>
            </Flex.row>
            {shipmentData.products &&
              shipmentData.products.length > 0 &&
              shipmentData.products.map((product, index) => (
                <Flex.row
                  key={`product-${index}`}
                  justify="space-between"
                  align="center"
                  sx={{ width: "100%", px: "5%", ...styles.box }}
                >
                  <span sx={{ lineHeight: 1.18 }}>{product.title}</span>
                  <div sx={{ flexBasis: "25px", flexGrow: 0, flexShrink: 0, textAlign: "right" }}>
                    {product.quantity}
                  </div>
                </Flex.row>
              ))}
            {shipmentData.products && shipmentData.products.length > 0 && (
              <Flex.row
                justify="space-between"
                align="center"
                sx={{ width: "100%", px: "5%", ...styles.box, mb: 4 }}
              >
                <span>Zielgewicht:</span>
                <div sx={{ flexBasis: "60px", flexGrow: 0, flexShrink: 0, textAlign: "right " }}>
                  {Math.round(Number(shipmentData.targetWeightKg) * 1000)} g
                </div>
              </Flex.row>
            )}
            {shipmentData.discounts && shipmentData.discounts.length > 0 && (
              <Flex.row justify="space-between" align="center" sx={{ width: "100%" }}>
                <span sx={{ fontWeight: "bold", fontFamily: "heading" }}>Gutscheine:</span>
                <span>{}</span>
              </Flex.row>
            )}
            {shipmentData.discounts &&
              shipmentData.discounts.length > 0 &&
              shipmentData.discounts.map((discount, index) => (
                <Flex.column
                  key={`discount-${index}`}
                  justify="flex-start"
                  align="flex-start"
                  sx={{ width: "100%", px: "5%", ...styles.box }}
                >
                  <div sx={{ flexBasis: "100%", flexGrow: 0, flexShrink: 0, lineHeight: 1.18 }}>
                    {discount.title}
                  </div>
                </Flex.column>
              ))}
            <Flex.row justify="space-between" align="center" sx={{ width: "100%", mt: 4 }}>
              <span sx={{ fontWeight: "bold", fontFamily: "heading" }}>
                DHL-Sendungsnummern und -links:
              </span>
              <span>{}</span>
            </Flex.row>
            {shipmentData.trackingNumbers ? (
              shipmentData.trackingNumbers.length === 0 ? (
                shipmentData.isOnlySchlafduoProbe ? (
                  <Flex
                    direction="row"
                    justify="center"
                    align="center"
                    sx={{ width: "100%", px: "5%", ...styles.box }}
                  >
                    <span>Briefsendung! Kein Tracking möglich!</span>
                  </Flex>
                ) : (
                  <Flex
                    direction="row"
                    justify="center"
                    align="center"
                    sx={{ width: "100%", px: "5%", ...styles.box }}
                  >
                    <span>Keine Trackingnummern vorhanden!</span>
                  </Flex>
                )
              ) : (
                shipmentData.trackingNumbers.map((number, index) => (
                  <Flex
                    key={`dhlNumber-${index}`}
                    direction={["column", "row"]}
                    justify={["flex-start", "space-between"]}
                    align="center"
                    sx={{ width: "100%", px: "5%", ...styles.box }}
                  >
                    <span>{number}</span>
                    <span sx={{ textAlign: "right" }}>
                      <a
                        href={`${shipmentData.trackingUrls[index]}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Sendungsverfolgung
                      </a>
                    </span>
                  </Flex>
                ))
              )
            ) : (
              <Flex
                direction="row"
                justify="center"
                align="center"
                sx={{ width: "100%", px: "5%", ...styles.box }}
              >
                <span>Keine Trackingnummern vorhanden!</span>
              </Flex>
            )}
            {shipmentData.hasOwnProperty("dhlEvents") && shipmentData.dhlEvents.length > 0 && (
              <Flex.row justify="space-between" align="center" sx={{ width: "100%" }}>
                <span sx={{ fontWeight: "bold", fontFamily: "heading" }}>DHL-Statusmeldungen:</span>
                <span>{}</span>
              </Flex.row>
            )}
            {shipmentData.hasOwnProperty("dhlEvents") &&
              shipmentData.dhlEvents.length > 0 &&
              shipmentData.dhlEvents
                .sort((a, b) => (a.time < b.time ? +1 : b.time < a.time ? -1 : 0))
                .map((dhlEvent, index) => {
                  const { time, status } = dhlEvent
                  return (
                    <Flex
                      key={`dhlEvent-${index}`}
                      direction={["column", "row"]}
                      justify={["flex-start", "space-between"]}
                      align="center"
                      sx={{ width: "100%", px: "5%", ...styles.box }}
                    >
                      <span
                        dangerouslySetInnerHTML={{ __html: translateDhl(status) }}
                        sx={{ lineHeight: 1.18 }}
                      />
                      <div
                        sx={{
                          flexBasis: ["unset", "220px"],
                          flexGrow: 0,
                          flexShrink: 0,
                          textAlign: ["center", "right"],
                          mt: [2, 0],
                        }}
                      >
                        {new Date(time).toLocaleString("de-DE", {
                          timeZone: "Europe/Berlin",
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </div>
                    </Flex>
                  )
                })}
          </div>
        )}
        {shipmentData.billbeeId && (
          <Fragment>
            <h2 sx={{ mt: 10 }}>Anfrage an den Support</h2>
            <form method="post" action="https://ticket.sleep.ink/" sx={{ mt: "50px" }}>
              <input type="hidden" name="name" value={shipmentData.name} />
              <input type="hidden" name="email" value={shipmentData.email} />
              <input
                type="hidden"
                name="subject"
                value={`Anfrage zur Bestellung ${shipmentData.orderNumber} (Billbee: ${shipmentData.billbeeId})`}
              />
              <input type="hidden" name="status" value="2" />
              <input type="hidden" name="priority" value="3" />
              <input
                type="hidden"
                name="custom_fields"
                value={JSON.stringify({
                  billbeeId: shipmentData.billbeeId,
                  orderNumber: shipmentData.orderNumber,
                })}
              />
              <Flex
                direction={["column", "row"]}
                justify={["flex-start", "space-between"]}
                align={["flex-start"]}
              >
                <label
                  htmlFor="description"
                  sx={{ flexBasis: ["unset", "120px"], flexGrow: 0, flexShrink: 0 }}
                >
                  Ihre Anfrage:
                </label>
                <textarea
                  rows="8"
                  name="description"
                  placeholder="Ihre Anfrage"
                  required
                  sx={{ padding: 4, width: "100%" }}
                ></textarea>
              </Flex>
              <div sx={{ textAlign: "center", width: "100%", mt: 5 }}>
                <button
                  type="submit"
                  sx={{
                    px: 5,
                    py: 4,
                    backgroundColor: "almostBlack",
                    color: "background",
                    textTransform: "uppercase",
                    fontWeight: "light",
                    opacity: 1,
                    "&:hover": {
                      opacity: 0.6,
                    },
                  }}
                >
                  absenden
                </button>
              </div>
            </form>
          </Fragment>
        )}
        {!shipmentData.billbeeId && error.extra && (
          <Fragment>
            <h2 sx={{ mt: 10 }}>Anfrage an den Support</h2>
            <form method="post" action="https://ticket.sleep.ink/" sx={{ mt: "50px" }}>
              <input type="hidden" name="email" value={shipmentData.email} />
              <input
                type="hidden"
                name="subject"
                value={`Anfrage zur Bestellung ${shipmentData.orderNumber}`}
              />
              <input type="hidden" name="status" value="2" />
              <input type="hidden" name="priority" value="3" />
              <input
                type="hidden"
                name="custom_fields"
                value={JSON.stringify({
                  orderNumber: shipmentData.orderNumber,
                })}
              />
              <Flex
                direction={["column", "row"]}
                justify={["flex-start", "space-between"]}
                align={["center"]}
                sx={{ mb: 4 }}
              >
                <label
                  htmlFor="email"
                  sx={{ flexBasis: ["unset", "180px"], flexGrow: 0, flexShrink: 0 }}
                >
                  Ihre E-Mail-Adresse:
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Ihre E-Mail-Adresse"
                  required
                  sx={{
                    padding: 4,
                    fontSize: 1,
                    color: "almostBlack",
                    borderColor: "rgba(47,78,37,0,15)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontWeight: "light",
                    minWidth: "350px",
                    mb: [3, 3, 3],
                  }}
                />
              </Flex>
              <Flex
                direction={["column", "row"]}
                justify={["flex-start", "space-between"]}
                align={["flex-start"]}
              >
                <label
                  htmlFor="description"
                  sx={{ flexBasis: ["unset", "120px"], flexGrow: 0, flexShrink: 0 }}
                >
                  Ihre Anfrage:
                </label>
                <textarea
                  rows="8"
                  name="description"
                  placeholder="Ihre Anfrage"
                  required
                  sx={{
                    padding: 4,
                    width: "100%",
                    borderColor: "rgba(47,78,37,0,15)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontWeight: "light",
                  }}
                ></textarea>
              </Flex>
              <div sx={{ textAlign: "center", width: "100%", mt: 5 }}>
                <button
                  type="submit"
                  sx={{
                    px: 5,
                    py: 4,
                    backgroundColor: "almostBlack",
                    color: "background",
                    textTransform: "uppercase",
                    fontWeight: "light",
                    opacity: 1,
                    "&:hover": {
                      opacity: 0.6,
                    },
                  }}
                >
                  absenden
                </button>
              </div>
            </form>
          </Fragment>
        )}
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { OrderRequest }
